<template>
  <div class="download-module-background">
    <div class="download-module-banner">
      <div class="download-module-container">
        <div class="download-module-banner-title">UTILITY</div>
      </div>

      <img class="download-module-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="download-module-container">

     <div class="download-module-content">
       <div class="download-module-content-title">
         <div class="download-module-content-title-text">UTILITY {{ $t("utility.title") }}</div>
         <div class="download-module-line"></div>
       </div>
       <div class="download-module-content-info">
         <p class="download-module-content-info-text">
          {{ $t("utility.titleP1") }}
         </p>
         <p class="download-module-content-info-text">{{ $t("utility.titleP2") }}</p>
       </div>

       <pre class="download-module-pre">
{{ $t("utility.titlePre01") }}
plot_band_structure.x

{{ $t("utility.titlePre02") }}
module load pwmat
plot_band_structure.x
       </pre>

       <p class="download-module-content-info-text"><a :href='UTILITY_DOWNLOAD+"utils.zip"'>{{ $t("utility.title2") }}</a></p>

<el-menu :default-active="0"  class="el-menu-demo" mode="horizontal" @select="handleSelect"
          background-color="rgba(73,145,201,1)"
          text-color="rgba(240,240,240,1)"
          size="large"
          active-text-color="rgba(240,240,240,1)">
  <el-menu-item v-for="(item,key) in newTable" :key="key" :index="key">{{item.title}}</el-menu-item>
  <!-- <el-menu-item index="2">数据可视化</el-menu-item>
  <el-menu-item index="3">数据后处理</el-menu-item> -->
</el-menu>

<div v-show="newTable[0].isShow">
       <div class="download-module-content-title">
         <div class="download-module-content-title-text">{{newTable[0].title}}</div>
         <div class="download-module-line"></div>
       </div>
       <div class="download-module-content-info">
         <table class="download-module-table" >
           <tr class="download-module-th">
             <th class="download-module-text-th"></th>
             <th class="download-module-text-th">{{ $t("utility.tableR0C1") }}</th>
             <th class="download-module-text-th">{{ $t("utility.tableR0C2") }}</th>
           </tr>
           <tbody v-for="(file,index) in formatConversion" :key="index" >
             <tr class="download-module-td" @click="showFormatConversInfo(file.id)">
               <td class="download-module-text-td">{{index+1}}</td>
               <td class="download-module-text-td"><a class="download-module-a">{{file.name}}</a></td>
               <td class="download-module-text-td">{{file.summary}}</td>
             </tr>
             <tr  v-show="isShowFormatConversInfo&&(showModuleInfoId === file.id)">
               <td class="download-module-td-info" colspan="3" >
                 <div class="download-module-content-info-text-td">教程：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.course_url">{{file.course_url.substring(12)}}</a></div>
                 <div class="download-module-content-info-text-td" v-show="file.software_url">文件下载：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.software_url">{{file.software_url? file.software_url.substring(13): ''}}</a></div>
               </td>
             </tr>
           </tbody>
         </table>
       </div>
</div>

<div v-show="newTable[1].isShow">
       <div class="download-module-content-title">
         <div class="download-module-content-title-text">{{newTable[1].title}}</div>
         <div class="download-module-line"></div>
       </div>
       <div class="download-module-content-info">
         <table class="download-module-table" >
           <tr class="download-module-th">
             <th class="download-module-text-th"></th>
             <th class="download-module-text-th">{{ $t("utility.tableR0C1") }}</th>
             <th class="download-module-text-th">{{ $t("utility.tableR0C2") }}</th>
           </tr>
           <tbody v-for="(file,index) in dataVisualization" :key="index" >
           <tr class="download-module-td" @click="showDataVisualizationInfo(file.id)">
             <td class="download-module-text-td">{{index+1}}</td>
             <td class="download-module-text-td"><a class="download-module-a">{{file.name}}</a></td>
             <td class="download-module-text-td">{{file.summary}}</td>
           </tr>
           <tr  v-show="isShowDataVisualizationInfo&&(showModuleInfoId === file.id)">
             <td class="download-module-td-info" colspan="3" >
               <div class="download-module-content-info-text-td">教程：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.course_url">{{file.course_url.substring(12)}}</a></div>
               <div class="download-module-content-info-text-td" v-show="file.software_url">文件下载：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.software_url">{{file.software_url? file.software_url.substring(13) : ''}}</a></div>
             </td>
           </tr>
           </tbody>
         </table>
       </div>
</div>

<div v-show="newTable[2].isShow">
       <div class="download-module-content-title">
         <div class="download-module-content-title-text">{{newTable[2].title}}</div>
         <div class="download-module-line"></div>
       </div>
       <div class="download-module-content-info">
         <table class="download-module-table" >
           <tr class="download-module-th">
             <th class="download-module-text-th"></th>
             <th class="download-module-text-th">{{ $t("utility.tableR0C1") }}</th>
             <th class="download-module-text-th">{{ $t("utility.tableR0C2") }}</th>
           </tr>
           <tbody v-for="(file,index) in dataPostProcessing" :key="index" >
           <tr class="download-module-td" @click="showDataPostProcessingInfo(file.id)">
             <td class="download-module-text-td">{{index+1}}</td>
             <td class="download-module-text-td"><a class="download-module-a">{{file.name}}</a></td>
             <td class="download-module-text-td">{{file.summary}}</td>
           </tr>
           <tr  v-show="isShowDataPostProcessingInfo&&(showModuleInfoId === file.id)">
             <td class="download-module-td-info" colspan="3" >
               <div class="download-module-content-info-text-td">教程：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.course_url">{{file.course_url.substring(12)}}</a></div>
               <div class="download-module-content-info-text-td" v-show="file.software_url">文件下载：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.software_url">{{file.software_url ? file.software_url.substring(13) : ''}}</a></div>
             </td>
           </tr>
           </tbody>
         </table>
       </div>
</div>

     </div>
    </div>
  </div>
</template>

<script>
  // import {formatConversionDownload,dataPostProcessingDownload,dataVisualizationDownload} from "../../helpers/utilityDownload_zh"
  import {UTILITY_DOWNLOAD,CMS_API_NEWS_IMG} from "../../helpers/consts";
  import {mapState} from 'vuex'

  export default {
    name: "companyIntroduce",
    data(){
      return {
        // formatConversionDownload,
        // dataPostProcessingDownload,
        UTILITY_DOWNLOAD,
        CMS_API_NEWS_IMG,
        // dataVisualizationDownload,
        isShowFormatConversInfo:false,
        isShowDataVisualizationInfo:false,
        isShowDataPostProcessingInfo:false,
        showModuleInfoId:'',
        newTable: [{title: this.$t("utility.menu1"), isShow: true},
                   {title: this.$t("utility.menu2"), isShow: false},
                   {title: this.$t("utility.menu3"), isShow: false},
                  ]
      }
    },
    computed: {
      ...mapState({
        formatConversion: state => state.Utility.formatConversion.info,
        dataVisualization: state => state.Utility.dataVisualization.info,
        dataPostProcessing: state => state.Utility.dataPostProcessing.info,
      }),
      // formatConversionDownload() {
      //   return require(`../../helpers/utilityDownload_${this.$i18n.locale}.js`).formatConversionDownload
      //          || require('../../helpers/utilityDownload_zh.js').formatConversionDownload;
      // },
    },
    created(){
      this.$store.dispatch('getFormatConversion').then(res => {
      })
      this.$store.dispatch('getDataVisualization').then(res => {
      })
      this.$store.dispatch('getDataPostProcessing').then(res => {
      })
    },
    methods:{
      showFormatConversInfo($id){
        if(this.isShowFormatConversInfo&&this.showModuleInfoId===$id){
          this.showModuleInfoId = ''
          this.isShowFormatConversInfo = false
          this.isShowDataVisualizationInfo = false
          this.isShowDataPostProcessingInfo = false
        }else{
          this.showModuleInfoId = $id
          this.isShowFormatConversInfo = true
          this.isShowDataVisualizationInfo = false
          this.isShowDataPostProcessingInfo = false
        }
      },
      showDataVisualizationInfo($id){
        if(this.isShowDataVisualizationInfo&&this.showModuleInfoId===$id){
          this.showModuleInfoId = ''
          this.isShowFormatConversInfo = false
          this.isShowDataVisualizationInfo = false
          this.isShowDataPostProcessingInfo = false
        }else{
          this.showModuleInfoId = $id
          this.isShowDataVisualizationInfo = true
          this.isShowFormatConversInfo = false
          this.isShowDataPostProcessingInfo = false
        }
      },
      showDataPostProcessingInfo($id){
        if(this.isShowDataPostProcessingInfo&&this.showModuleInfoId===$id){
          this.showModuleInfoId = ''
          this.isShowFormatConversInfo = false
          this.isShowDataVisualizationInfo = false
          this.isShowDataPostProcessingInfo = false
        }else{
          this.showModuleInfoId = $id
          this.isShowDataPostProcessingInfo = true
          this.isShowFormatConversInfo = false
          this.isShowDataVisualizationInfo = false
        }
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath)
        console.log(key)
        switch(key) {
          case 0:    // 格式转换
            this.newTable[0].isShow = true
            this.newTable[1].isShow = false
            this.newTable[2].isShow = false
            console.log(this.newTable[0])
            break;
          case 1:    // 数据可视化
            this.newTable[0].isShow = false
            this.newTable[1].isShow = true
            this.newTable[2].isShow = false
            console.log(this.newTable[1])
            break;
          case 2:    // 数据后处理
            this.newTable[0].isShow = false
            this.newTable[1].isShow = false
            this.newTable[2].isShow = true
            console.log(this.newTable[2])
            break;
        }
      },
    }
  }
</script>

<style scoped>
  .download-module-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .download-module-background{
    margin-top: 70px;
  }
  .download-module-banner{
    overflow:hidden;
  }
  .download-module-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .download-module-banner-img{
    min-width:100%;
    height:165px;
  }
  .download-module-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .download-module-content-title{
    padding-top: 50px;
  }
  .download-module-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .download-module-content-info{
    margin-top: 40px;
  }
  .download-module-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .download-module-content-info-text-td{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .download-module-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .download-module-content-img{
    text-align: center;
  }
  .download-module-content-img-png{
    margin-top: 50px;
    width: 800px;
  }
  .download-module-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .download-module-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .download-module-td{
    cursor: pointer;
    height: 45px;
  }
  .download-module-td:hover{
    background:rgba(73,145,201,0.15);
  }
  .download-module-td-info{
    height: 45px;
    padding: 16px 32px;
    background:rgba(73,145,201,0.05);
  }
  .download-module-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding:8px 16px;
  }
  .download-module-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding:8px 16px;
  }
  .download-module-a{
    color:rgba(73,145,201,1)!important;
  }
  .download-module-pre{
    background:rgba(73,145,201,0.1);
    padding: 24px 32px;
  }

  @media screen and (max-width:482px) {
    .download-module-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .download-module-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .download-module-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .download-module-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .download-module-container{
      max-width: 1068px;
    }
  }

</style>
